import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const rows = [
  {
    id: 1,
    idName: "John",
    email: "john@example.com",
    comment: "Service is not bad",
  },
  {
    id: 2,
    idName: "Jane",
    email: "jane@example.com",
    comment: "Could be better",
  },
  {
    id: 3,
    idName: "Bob",
    email: "bob@example.com",
    comment: "Sed do eiusmod tempor incididunt",
  },
];

function Feedbacks() {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Views</TableCell>
            <TableCell align="right">Id Name</TableCell>
            <TableCell align="right">Email</TableCell>
            <TableCell align="right">Comment</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell component="th" scope="row">
                {row.id}
              </TableCell>
              <TableCell align="right">{row.idName}</TableCell>
              <TableCell align="right">{row.email}</TableCell>
              <TableCell align="right">{row.comment}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Feedbacks;
